


















































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import UserService from '@/services/UserService'
import {
  RegistrationFormData,
  RegistrationTsSurveyData
} from '@/interfaces/UserInterfaces'
import LocaleHelper from '@/utils/LocaleHelper'
import { EventBus } from '@/main'
import SurveyHelper from '@/utils/SurveyHelper'
import { SelectOption } from '@/interfaces/GeneralInterfaces'

@Component({ name: 'SignUpForm' })
export default class SignUpForm extends Vue {
  @Prop({ default: '' })
  surveyProduct?: string

  @Prop({ default: '' })
  accessCode?: string

  registrationData: RegistrationFormData = {
    candidateNumber: null,
    gender: null,
    locale: ''
  }

  candidateNumberIsFree: boolean = true
  genderRequiredError: boolean = false
  error: string | null = null
  genderOptions: Array<SelectOption> = []

  async created () {
    this.genderOptions = [
      {
        label: this.$tc('male'),
        value: 1
      },
      {
        label: this.$tc('female'),
        value: 2
      }
    ]
  }

  async checkCandidateNumber () {
    this.candidateNumberIsFree =
      await UserService.checkCandidateNumberAvailability(
        this.registrationData.candidateNumber
      )
  }

async submit () {
  await this.checkCandidateNumber()

  this.genderRequiredError =
    !this.registrationData.gender ||
    (!this.registrationData.gender.value &&
      this.registrationData.gender.value !== 0)

  this.error = ''

  if (
    !await this.$validator.validateAll() ||
    !this.candidateNumberIsFree ||
    this.genderRequiredError
  ) {
    const errorElement = this.$el.querySelector('.error')
    if (errorElement) {
      errorElement.scrollIntoView(false)
    }
    return
  }

  try {
    this.registrationData.locale = LocaleHelper.getUserLocale()

    let registrationData = {}

    if (this.surveyProduct === SurveyHelper.TS && this.accessCode) {
      const registrationTsSurveyData: RegistrationTsSurveyData = {
        ...this.registrationData,
        gender: this.registrationData.gender
          ? this.registrationData.gender.value
          : null,
        accessCode: this.accessCode
      }

      registrationData = await UserService.tsSurveyRegistration(
        registrationTsSurveyData
      )
    } else {
      registrationData = await UserService.registration({
        candidateNumber: this.registrationData.candidateNumber,
        gender: this.registrationData.gender
          ? this.registrationData.gender.value
          : null,
      })
    }

    await this.$auth.setToken(registrationData)
    await UserService.getUser()
    EventBus.$emit('authorizedComplete')
} catch (error) {
  console.log('========== REGISTRATION ERROR ==========')
  console.log(error)

  if ('response' in error) {
    console.log(error.response)
    console.log(error.response.data)
    alert(JSON.stringify(error.response.data))
  } else {
    alert('No response from backend')
  }

  if ('response' in error && error.response.status === 400) {
    this.handleRegistrationErrors(error.response.data)
  } else {
    this.error = error.message
  }
}
}


  @Watch('registrationData.gender')
  genderChanged () {
    this.genderRequiredError =
      !this.registrationData.gender ||
      (!this.registrationData.gender.value &&
        this.registrationData.gender.value !== 0)
  }

  handleRegistrationErrors (data: object) {
    // TODO: Handle registration errors
  }

  changeForm (formName: string) {
    this.$emit('changeForm', formName)
  }
}
